import styled from 'styled-components';
import { device } from '../theme/devices';

export const NavbarContainer = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 60px;

  @media ${device.mobile} {
    padding: 10px;
  }

  div {
    a {
      color: #fff;
      text-decoration: none;
      font-size: 20px;
      margin-right: 95px;
      width: auto;

      :hover {
        color: ${({ theme }) => theme?.secondaryColor};
      }

      @media ${device.mobile} {
        font-size: 16px;
        margin-right: 15px;
      }
    }
  }

  img {
    width: 190px;
    height: auto;
    margin: 0;
  }
`;
